import { useState } from "react";
import { IBeneficiary } from "./AppManualInsert.types";
import { Accordion } from "v2/components";
import { Label, LableTitle, Span } from "./AppManualInsert.styled";
import { cpfMask, formatCPF } from "utils/cpf";
import { formatCNPJ } from "utils/is-valid-cnpj";
import EditIcon from '@mui/icons-material/Edit';
import { Button, IconButton } from "@mui/material";
import { fieldOptions } from "./AppManualInsert.utils";
import AddIcon from '@mui/icons-material/Add';
import WritingOnBoard from "components/svg/writing-on-board";
import DeleteIcon from '@mui/icons-material/Delete';

interface IProps {
  beneficiaries: IBeneficiary[];
  handleAdd: () => void;
  handleEdit: (taxPayerId: string) => void;
  handleDelete: (taxPayerId: string) => void;
  isCLT: boolean;
}

export function AppManualInsertSummary({ beneficiaries, handleAdd, handleEdit, handleDelete, isCLT }: IProps) {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <>
      {!beneficiaries.length ? (
        <div style={{ display: "flex", height: "400px", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px" }}>
          <WritingOnBoard />
          <p style={{ fontSize: '18px', color: '#6F6F78', fontWeight: "700" }}>Use o botão abaixo para adicionar um beneficiário.</p>
          <Button
              variant="text"
              style={{
                paddingTop: "0.25rem",
                paddingBottom: "0.25rem",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                borderRadius: "0.375rem",
                height: "2.5rem",
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
                fontWeight: 600,
              }}
              startIcon={<AddIcon color="primary" />}
              onClick={handleAdd}
            >
              Adicionar beneficiário
            </Button>
        </div>
      ) : (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "24px" }}>
          <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
            <span style={{ fontSize: "16px", fontWeight: "700", color: "rgba(15, 15, 30, 0.60)" }}>{beneficiaries.length} Beneficiário(s)</span>
            <Button
              variant="text"
              style={{
                paddingTop: "0.25rem",
                paddingBottom: "0.25rem",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                borderRadius: "0.375rem",
                height: "2.5rem",
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
                fontWeight: 600,
              }}
              startIcon={<AddIcon color="primary" />}
              onClick={handleAdd}
            >
              Adicionar beneficiário
            </Button>
          </div>
          {beneficiaries.map((beneficiary) => (
            <Accordion
              key={beneficiary.taxPayerId}
              expanded={selected === beneficiary.taxPayerId}
              onExpand={() => selected === beneficiary.taxPayerId ? setSelected(null) : setSelected(beneficiary.taxPayerId)}
              options={
                <>
                  <IconButton color="error" size="small" onClick={() => handleDelete(beneficiary.taxPayerId)}>
                    <DeleteIcon />
                  </IconButton>
                  <IconButton color="primary" size="small" onClick={() => handleEdit(beneficiary.id)}>
                    <EditIcon />
                  </IconButton>
                </>
              }
              header={
                <div style={{ width: "100%", display: "flex" }}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", flex: "1" }}>
                    <Label>Nome completo sem abreviações</Label>
                    <LableTitle>{beneficiary.name}</LableTitle>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", flex: "1" }}>
                    <Label>CPF</Label>
                    <LableTitle>{cpfMask(beneficiary.taxPayerId)}</LableTitle>
                  </div>
                  {!isCLT && (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", flex: "1" }}>
                      <Label>CNPJ da empresa do beneficiário</Label>
                      <LableTitle>{formatCNPJ(beneficiary.legalEntityId, false)}</LableTitle>
                    </div>
                  )}
                </div>
              }
            >
              <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "8px" }}>
                {Object.entries(beneficiary).filter(([key]) => key !== "id").map(([key, value]) => (
                  <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <Label>{fieldOptions.find(option => option.id === key)?.name}</Label>
                    <Span>{key === "taxPayerId" ? formatCPF(value, false) : key === "legalEntityId" ? formatCNPJ(value, false) : value}</Span>
                  </div>
                ))}
              </div>
            </Accordion>
          ))}
        </div>
      )}
    </>
  );
}
